var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12" } },
    [
      _c(
        "v-form",
        { ref: "certificateForm" },
        [
          _c(
            "base-card",
            { staticClass: "custom-card" },
            [
              _c("v-card-title", [_vm._v("Certificado Digital")]),
              _c(
                "v-card-text",
                [
                  _c("v-row", [
                    _c("div", [
                      _c("h6", { staticClass: "ms-3" }, [
                        _vm._v("Vigencia del certificado"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c("v-text-field", {
                            ref: "FechaDesde",
                            attrs: {
                              label: "Desde",
                              "prepend-inner-icon": "mdi-calendar",
                              disabled: "",
                            },
                            model: {
                              value: _vm.dataCertificate.FechaDesde,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataCertificate, "FechaDesde", $$v)
                              },
                              expression: "dataCertificate.FechaDesde",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c("v-text-field", {
                            ref: "FechaHasta",
                            attrs: {
                              label: "Hasta",
                              "prepend-inner-icon": "mdi-calendar",
                              disabled: "",
                            },
                            model: {
                              value: _vm.dataCertificate.FechaHasta,
                              callback: function ($$v) {
                                _vm.$set(_vm.dataCertificate, "FechaHasta", $$v)
                              },
                              expression: "dataCertificate.FechaHasta",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-row", [
                    _c("div", [
                      _c("h6", { staticClass: "ms-3" }, [
                        _vm._v("Configuración de Alerta"),
                      ]),
                    ]),
                  ]),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c("v-text-field", {
                            ref: "DiasAlertar",
                            attrs: {
                              label: "Alertar cuando falten (Días)",
                              "prepend-inner-icon": "mdi-calendar-clock",
                              type: "number",
                              clearable: "",
                              rules: _vm.formRules,
                              "error-messages": _vm.errorMessages,
                            },
                            model: {
                              value: _vm.dataCertificate.DiasAlertar,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dataCertificate,
                                  "DiasAlertar",
                                  $$v
                                )
                              },
                              expression: "dataCertificate.DiasAlertar",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "3" } },
                        [
                          _c("v-text-field", {
                            ref: "DiasRepetirAlerta",
                            attrs: {
                              label: "Repetir alerta cada (Días)",
                              "prepend-inner-icon": "mdi-reload",
                              type: "number",
                              clearable: "",
                              rules: _vm.formRules,
                              "error-messages": _vm.errorMessages,
                            },
                            model: {
                              value: _vm.dataCertificate.DiasRepetirAlerta,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.dataCertificate,
                                  "DiasRepetirAlerta",
                                  $$v
                                )
                              },
                              expression: "dataCertificate.DiasRepetirAlerta",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-col", { attrs: { cols: "12", sm: "4" } }),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "2" } },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-2",
                              staticStyle: {
                                "background-color": "rgb(204 33 40)",
                                color: "white !important",
                              },
                              on: { click: _vm.validateCertificateData },
                            },
                            [_vm._v(" Guardar ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-alert",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.successAlert,
                              expression: "successAlert",
                            },
                          ],
                          attrs: { type: "success", text: "" },
                        },
                        [_vm._v(" " + _vm._s(_vm.msgSuccessAlert) + " ")]
                      ),
                      _c("p"),
                    ],
                    1
                  ),
                  _c("p"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }